module.exports = __webpack_public_path__ + "static/img/zongji5.a0cec461.png";